import { mapState, mapGetters, mapActions } from 'vuex'

export const profileQuestionnaireComputed = {
  ...mapState('profileQuestionnaire', {
    profileQuestionnaire: (state) => state.questionnaire,
  }),
  ...mapGetters('profileQuestionnaire', ['getQuestionnaire']),
}

export const questionnaireMethods = mapActions('profileQuestionnaire', [
  'setQuestionnaire',
])
